import * as React from "react";
import { createConnectedRouter, createRender } from "found";

import { HomeWrapper } from "@components/home-wrapper";
import { NoRouteView } from "@components/no-route-view";

export const ConnectedRouter = createConnectedRouter({
  render: createRender({
    // currently never shows
    renderPending: () => (
      <div className="cwBoxed">
        <div className="loader-clock" id="cwloader">
          <div className="loader-clock-center"></div>
          <div className="loader-clock-minute"></div>
          <div className="loader-clock-hour"></div>
        </div>
      </div>
    ),
    // currently never shows
    renderError: ({ error }: { error: any }) => {
      // non 404s
      if (error.status !== 404) {
        return <div>Error</div>;
      }

      return (
        <HomeWrapper>
          <NoRouteView />
        </HomeWrapper>
      );
    },
  }),
});
